"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Button = _interopRequireDefault(require("../Button"));
var _Menu = _interopRequireDefault(require("../Menu"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var value = props.value,
    children = props.children,
    triggerProps = props.triggerProps,
    onClickOutside = props.onClickOutside,
    label = props.label,
    listProps = props.listProps,
    onChange = props.onChange,
    variant = props.variant,
    size = props.size,
    disabled = props.disabled,
    closeOnScrollOutside = props.closeOnScrollOutside,
    filterdProps = __rest(props, ["value", "children", "triggerProps", "onClickOutside", "label", "listProps", "onChange", "variant", "size", "disabled", "closeOnScrollOutside"]);
  var _a = (0, _react.useState)(null),
    triggerRef = _a[0],
    setTriggerRef = _a[1];
  var _b = (0, _react.useState)(false),
    isOpen = _b[0],
    setIsOpen = _b[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      open: function open() {
        return setIsOpen(true);
      },
      close: function close() {
        return setIsOpen(false);
      }
    };
  }, []);
  var handleOnClickOutside = (0, _react.useCallback)(function (event) {
    if (typeof onClickOutside === 'function') {
      onClickOutside(event);
    }
    setIsOpen(false);
  }, [onClickOutside]);
  var toggleOpen = (0, _react.useCallback)(function () {
    setIsOpen(function (current) {
      return !current;
    });
  }, []);
  var handleOnKeyDown = (0, _react.useCallback)(function (event) {
    if (typeof (listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown) === 'function') {
      listProps.onKeyDown(event);
    }
    if (isOpen) {
      switch (event.code) {
        case 'Escape':
          {
            event.preventDefault();
            event.stopPropagation();
            setIsOpen(false);
          }
      }
    }
  }, [isOpen, listProps]);
  var handleOnSelect = (0, _react.useCallback)(function (value) {
    if (typeof onChange === 'function') {
      onChange(value);
    }
    setIsOpen(false);
  }, [onChange]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_Button.default, __assign({
      ref: setTriggerRef,
      disabled: disabled
    }, triggerProps, {
      variant: variant,
      size: size,
      onClick: toggleOpen
    }, {
      children: [label, (0, _jsxRuntime.jsx)(Styled.Icon, {
        "$isOpen": isOpen
      })]
    })), (0, _jsxRuntime.jsx)(_Menu.default, __assign({}, filterdProps, {
      ref: undefined,
      show: isOpen,
      anchor: triggerRef,
      onClickOutside: handleOnClickOutside,
      onScrollOutside: closeOnScrollOutside ? toggleOpen : undefined,
      listProps: __assign(__assign({}, listProps), {
        onSelect: handleOnSelect,
        onKeyDown: handleOnKeyDown
      })
    }, {
      children: _react.Children.map(children, function (child) {
        var _a;
        if (child) {
          var childElement = child;
          var childProps = __assign(__assign({}, childElement.props), {
            selected: value !== undefined && value === ((_a = childElement.props) === null || _a === void 0 ? void 0 : _a.value)
          });
          return /*#__PURE__*/(0, _react.cloneElement)(childElement, childProps);
        } else {
          return null;
        }
      })
    }))]
  });
});
Dropdown.displayName = 'Dropdown';
var _default = Dropdown;
exports.default = _default;